module.exports = __webpack_public_path__ + "static/img/detail.8306543.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/order/detail.png
// module id = dJIa
// module chunks = 1